//
//
//
//
//
//
//
//
//
//
//
//
//

import OrganisationProfileSidebar from "~/components/organisations/OrganisationProfileSidebar.vue";

export default {
	name: "organisations-slug",
	components: {
		OrganisationProfileSidebar,
	},
	async asyncData({ params, store }) {
		if (!store.state.init) await store.dispatch("init");
		const slug = params.slug;
		await store.dispatch("organisations/fetchOrganisation", slug);
		const organisation = store.getters["organisations/getOrganisationBySlug"](slug);
		await store.dispatch("rankings/fetchRanking", organisation.id);
		const ranking = store.getters["rankings/getRanking"](organisation.id);
		return {
			slug,
			organisation,
			ranking,
		};
	},
	nuxtI18n: {
		paths: {
			en: "/organisations/:slug",
			de: "/organisationen/:slug",
			fr: "/organisations/:slug",
			it: "/organizzazioni/:slug",
		},
	},
	data() {
		return {
			rankingViewName: "organisations-slug",
			rankingViews: [
				{
					name: "parliamentarians",
					path: "",
				},
				{
					name: "parties",
					path: "-parties",
				},
				{
					name: "factions",
					path: "-factions",
				},
			],
		};
	},
};
